import { createSlice } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { post } from 'utils/rest'
import * as Toast from 'components/Toast'

export interface ForgotPasswordState {
  hasSentMail: boolean
  isLoading: boolean
  hasError: boolean
}

const createInitialStateForgotPasswordState = (): ForgotPasswordState => {
  return {
    hasSentMail: false,
    isLoading: false,
    hasError: false,
  }
}

export const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState: createInitialStateForgotPasswordState(),
  reducers: {
    sendingMail: (state) => {
      state.isLoading = true
      state.hasSentMail = false
      state.hasError = false
    },
    sentMailSuccess: (state) => {
      state.isLoading = false
      state.hasSentMail = true
      state.hasError = false
    },
    sentMailFail: (state) => {
      state.isLoading = false
      state.hasSentMail = false
      state.hasError = true
    },
  },
})

export const { sendingMail, sentMailSuccess, sentMailFail } = forgotPasswordSlice.actions

export const forgotPasswordAsync =
  (email: string): AppThunk =>
  async (dispatch) => {
    dispatch(sendingMail())
    try {
      const response = await post<boolean>('/api/authentication/forgotpassword', email)

      if (response.status === 200 && response.parsedBody?.data === true) {
        dispatch(sentMailSuccess())
      } else {
        dispatch(sentMailFail())
        Toast.dispatchToastError({
          message: response.parsedBody?.message ?? 'Ett fel uppstod vid l�senords�terst�llning',
        })
      }
    } catch (err) {
      dispatch(sentMailFail())
    }
  }

export const selectForgotPasswordState = (state: RootState): ForgotPasswordState => state.forgotpassword

export default forgotPasswordSlice.reducer
